export default {
  marketing: {
    cookie: ["usida", "datr"],
  }
};
